export default __webpack_public_path__ + "static/media/diet.02796de5.svg";